import {useSelector} from 'react-redux';
import {selectCurrentActiveRoles, selectCurrentUserRoles} from 'features'

function useActiveRole() {
    
    const activeRoles = useSelector(selectCurrentActiveRoles)
    const userRoles = useSelector(selectCurrentUserRoles)

    function isOraculo () {
        return userRoles.includes(process.env.REACT_APP_MASTER_ROLE);
    }

    /**
     * React Component Display children if user role is included in the roles array
     * @param {*} _props 
     * @returns {children: ReactNode|null}
     */
    function RoleHasAccess(_props) {
        const {roles=[], children} = _props;
        if (roleHasAccess(roles)) {
            return children;
        }
        return null;
    }

    
    /**
     * React Component Display children if user role is NOT included in the roles array
     * @param {*} _props 
     * @returns {children: ReactNode|null}
     */
    function RoleHasNoAccess(_props) {
        const {roles=[], children} = _props;
        if (roleHasAccess(roles)) {
            return null;
        }
        return children;
    }

    /**
     * Function to check if user role is included in the roles array
     * @param {*} roles 
     * @returns 
     */
    function roleHasAccess (roles=[]) {
        if (roles.length === 0) return true
        return roles.some((role) => /* options?.useCurrent ? userRoles.includes(role) : */ activeRoles.includes(role));
    }

    /**
     * Function to check if user role is included in the roles array
     * @param {*} roles 
     * @returns 
     */
    function roleHasNoAccess (roles=[]) {
        if (roles.length === 0) return true
        return roles.every((role) => activeRoles.every(activeRole => activeRole !== role));
    }

    return [ activeRoles, {RoleHasAccess, RoleHasNoAccess, roleHasAccess, roleHasNoAccess, isOraculo} ];
}

export default useActiveRole;